import type { FC } from 'react';

import { t } from '@luna/i18n';

import { TextSymbol } from './TextSymbol';

interface Props {
    variableSymbol?: string | null;
    constantSymbol?: string | null;
    specificSymbol?: string | null;
}

export const AdditionalTextsSymbols: FC<Props> = ({
    constantSymbol,
    variableSymbol,
    specificSymbol,
}) => {
    return (
        <>
            <TextSymbol
                data-cy="variable-text-symbol"
                label={t('transaction.symbolsVariableSymbol')}
                value={variableSymbol}
            />
            <TextSymbol
                data-cy="constant-text-symbol"
                label={t('transaction.symbolsConstantSymbol')}
                value={constantSymbol}
            />
            <TextSymbol
                data-cy="specific-text-symbol"
                label={t('transaction.symbolsSpecificSymbol')}
                value={specificSymbol}
            />
        </>
    );
};
